module.exports = __webpack_public_path__ + "media/images/italic-e342e7c16fa5b423c1c8cb7846205bca.png";